<script>
  import { RuleBlock } from '@client/components/rule-block';

  export let row = {};
</script>

<div class="filename">{row.filename}</div>
<div class="rulename">
  <RuleBlock text="[[doc:{row.rulename}]]" />
</div>

<style lang="scss">
  .rulename {
    display: inline-flex;
    margin-top: var(--margin-base);
  }
</style>
